const paginator = async (items: Array<any>, currentPage: number, pageSize = 10) => {
  const totalPages = Math.ceil(items.length / pageSize);
  const offset = (currentPage - 1) * pageSize;
  const prePage = currentPage - 1 ? currentPage - 1 : null;
  const nextPage = (totalPages > currentPage) ? currentPage + 1 : null;

  const paginatedItems = items.slice(offset, currentPage * pageSize);
  return new Promise((resolve, reject) => {
    if (totalPages >= currentPage) {
      resolve({
        currentPage,
        pageSize,
        prePage,
        nextPage,
        totalPages,
        total: items.length,
        data: paginatedItems
      });
    } else {
      resolve(null);
    }
  });
}

export { paginator };
